// Keep existing guide/menu links pointed at the unified destination selectors (one page per destination).
// Cart forms, variant IDs, and fulfillment data remain unchanged.
// 2026-11-01: 泰國／越南／菲律賓／歐洲／澳洲 added (snippets/yc-shop-*.liquid via sections/yc-country-entry.liquid).
(() => {
  if (location.pathname === '/cart' || location.pathname.startsWith('/checkouts/')) return;
  function newMarketUrl(url) {
    const match = url.pathname.match(/^(.*?)(?:\/collections\/[^/]+)?\/products\/singapore-malaysia-thailand-(light|max|flex)-esim\/?$/);
    if (!match || url.origin !== location.origin) return null;
    const destination = new URL(url.href);
    destination.pathname = match[1] + '/collections/singapore-malaysia-thailand-esim';
    destination.searchParams.set('plan', match[2]);
    return destination.href;
  }
  const currentDestination = newMarketUrl(new URL(location.href));
  if (currentDestination && !window.Shopify?.designMode) {
    location.replace(currentDestination);
    return;
  }

  const destinations = new Map([
    ['japan-unlimited-esim','japan-esim'],['japan-daily-esim','japan-esim'],['japan-flex-esim','japan-esim'],
    ['korea-max-esim','korea-esim'],['korea-light-esim','korea-esim'],['korea-flex-esim','korea-esim'],
    ['thailand-youyou-max-esim','thailand-esim'],
    ['vietnam-max-esim','vietnam-esim'],['vietnam-light-esim','vietnam-esim'],
    ['philippines-max-esim','philippine-esim'],['philippines-light-esim','philippine-esim'],
    ['europe-max-esim','europe-esim'],
    ['australia-max-esim','australia-esim']
  ]);
  const selector = ['japan','korea','thailand','vietnam','philippines','europe','australia','singapore-malaysia-thailand'].map(prefix => `a[href*="/products/${prefix}-"]`).join(',');
  const updateLinks = (root) => {
    root.querySelectorAll(selector).forEach((link) => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      const combinedDestination = newMarketUrl(url);
      if (combinedDestination) {
        link.href = combinedDestination;
        return;
      }
      const match = url.pathname.match(/^(.*)\/products\/([^/]+)\/?$/);
      if (!match || !destinations.has(match[2])) return;
      const prefix = match[1].includes('/collections/') ? '' : match[1];
      link.href = `${prefix}/collections/${destinations.get(match[2])}`;
    });
  };
  const run = () => updateLinks(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true});
  else run();
  document.addEventListener('shopify:section:load', run);
})();
